import React, { useState } from "react"
import Card from "@material-ui/core/Card";
import moment from 'moment'
import { formatAsMoneyFromBilling  } from '../../utils/utils'
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import IconButton from "@material-ui/core/IconButton";
import Collapse from "@material-ui/core/Collapse";

function PreviewCard(props) {

    const { charge } = props

    const [expanded, setExpanded] = useState(false);
    const handleExpand = (event) => {
        event.stopPropagation();
        setExpanded(!expanded);
    };

    return (
        <>
            <Card className={["listCard", "collapse"].join(" ")}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div className="listCardItem normalText subtitleSize"
                         style={{ flex: "1 1 220px", textAlign: "center" }}
                    >
                            {charge.charge_key}
                    </div>
                    <div
                        className={["listCardItem", "normalText", "subtitleSize"].join(" ")}
                        style={{ flex: "1 1 130px", textAlign: "center" }}
                    >
                        {formatAsMoneyFromBilling(charge.amount, "-")}
                    </div>
                    <div
                        className={["listCardItem", "normalText", "subtitleSize", "noWrap"].join(" ")}
                        style={{ flex: "1 1 110px", textAlign: "center" }}
                    >
                        {moment(charge.created_at).format("DD/MM/YYYY HH:mm:ss")}
                    </div>
                    <div
                        className={["listCardItem", "normalText", "subtitleSize", "noWrap"].join(" ")}
                        style={{ flex: "1 1 40px", textAlign: "center" }}
                    >
                        <IconButton onClick={handleExpand}>
                            {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                        </IconButton>
                    </div>
                </div>
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                    <div className="listCardHeader">
                        <div
                            className={["listCardItem", "normalText", "normalSmallSize"].join(" ")}
                            style={{ flex: "1 1 220px", textAlign: "center" }}
                        >
                            Serviço
                        </div>
                        <div
                            className={["listCardItem", "normalText", "normalSmallSize"].join(" ")}
                            style={{ flex: "1 1 130px", textAlign: "center" }}
                        >
                            Valor
                        </div>
                        <div
                            className={["listCardItem", "normalText", "normalSmallSize"].join(" ")}
                            style={{ flex: "1 1 110px", textAlign: "center" }}
                        >
                            Data inicial
                        </div>
                    </div>
                    {
                        Object.entries(charge.charges).map(([product_name, product_data]) => (
                            <Card className="listCard">
                                <div className="listCardItem normalText subtitleSize" 
                                    style={{ flex: "1 1 220px", textAlign: "center" }}
                                >
                                    {product_name}
                                </div>

                                <div
                                    className={["listCardItem", "normalText", "subtitleSize"].join(" ")}
                                    style={{ flex: "1 1 130px", textAlign: "center" }}
                                >
                                    {formatAsMoneyFromBilling(product_data.total_amount_with_discounts, "-")}
                                </div>

                                <div
                                    className={["listCardItem", "normalText", "subtitleSize", "noWrap"].join(" ")}
                                    style={{ flex: "1 1 110px", textAlign: "center" }}
                                >
                                    {moment(charge.created_at).format("DD/MM/YYYY HH:mm:ss")}
                                </div>
                            </Card>
                        ))
                    }
                </Collapse>
            </Card>
        </>

    )
}

export default PreviewCard